import { gray, red, yellow } from "ansis";
import { assertNever } from "../assert-never";
export function colorize(level, message) {
    switch (level) {
        case "info": {
            return gray `${message}`;
        }
        case "warn": {
            return yellow `${message}`;
        }
        case "error": {
            return red `${message}`;
        }
        default: {
            assertNever(level);
        }
    }
}
//# sourceMappingURL=colorize.js.map